import { Directive, Input, ElementRef, OnInit } from '@angular/core';

enum Team { UNKNOWN = 'unknown'}

@Directive({
  selector: '[appTeamId2teamName]'
})
export class TeamId2teamNameDirective implements OnInit {

  @Input() id: any;
  @Input() teams: any;

  constructor(private el: ElementRef) { }

  getTeamNameFromID(): Team {

    if (this.id) {
      for (let team of this.teams) {
        if (this.id === team.id) {
          return team.name;
        }
      }
      return Team.UNKNOWN ;
    }

}

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    nativeElement.innerText = this.getTeamNameFromID();
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/teamid2teamname/teamid2teamname.directive.ts